// Lib
import React from 'react';

// Types
import useElementPlaceholderState, { RenderElementPlaceholderProps } from './useElementPlaceholderState';

/**
 * Decorator that adds element placeholder functionality to a component.
 * Keeps track of the visibility of the element and passes a placeholder component and boolean
 * telling the child whether to render that placeholder.
 */
export default (DecoratedComponent: React.ComponentType<RenderElementPlaceholderProps>) => {
    return (props: RenderElementPlaceholderProps): JSX.Element => {
        const placeholderProps = useElementPlaceholderState(props);
        return <DecoratedComponent {...props} {...placeholderProps} />;
    };
};
